import { render } from "./DataListActions.vue?vue&type=template&id=0634db32"
import script from "./DataListActions.vue?vue&type=script&lang=js"
export * from "./DataListActions.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Pages/DataListActions.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0634db32"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0634db32', __exports__)) {
    console.log('reload')
    api.reload('0634db32', __exports__)
  }
  
  module.hot.accept("./DataListActions.vue?vue&type=template&id=0634db32", () => {
    console.log('re-render')
    api.rerender('0634db32', render)
  })

}


export default __exports__